import { useInfiniteQuery } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { TOKEN_NAME, COMPANY_ID } from "../../config";
import axios from "../../api/axios";

const cookies = new Cookies();

const useInfiniteGet = ({
  url,
  params = {},
  key,
  enabled = true,
  limit = 10,
  isIncludeCompanyId = false,
  pageParamName = "page_number",
}) => {
  const company_id = cookies.get(COMPANY_ID);

  const fetchData = async ({ pageParam = 0 }) => {
    const token = cookies.get(TOKEN_NAME);

    const queryParams = {
      ...params,
      [pageParamName]: pageParam,
      limit,
      ...(isIncludeCompanyId && { company_id }),
    };

    const response = await axios.get(`/${url}`, {
      params: queryParams,
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });

    return response.data;
  };

  return useInfiniteQuery({
    queryKey: [...key, params, ...(isIncludeCompanyId ? [company_id] : [])],
    queryFn: fetchData,
    enabled,
    getNextPageParam: (lastPage, allPages) => {
      const pagination = lastPage?.pagination_data || lastPage?.pagination;

      if (pagination?.has_more_pages === false || pagination?.hasMorePages === false) {
        return undefined;
      }
      if (pagination?.has_more_pages === true || pagination?.hasMorePages === true) {
        if (typeof pagination?.current_page_number === "number") {
          return pagination.current_page_number + 1;
        }
        return allPages.length;
      }

      const totalFetched = allPages.reduce(
        (acc, page) => acc + (page?.data?.length || 0),
        0
      );
      const totalCount =
        pagination?.total_count ||
        pagination?.totalCount ||
        lastPage?.total_count ||
        lastPage?.totalCount ||
        0;

      if (totalCount && totalFetched >= Number(totalCount)) {
        return undefined;
      }

      if (lastPage?.data && lastPage.data.length >= limit) {
        return allPages.length;
      }

      return undefined;
    },
  });
};

export default useInfiniteGet;
